import React, { useEffect, useState } from 'react';
import { withRouter } from "react-router-dom";

import { Helmet } from 'react-helmet';

import {Footer} from '../../components/footer';
import Carousel from '../../components/carousel';
import BlackPlanTable from '../../components/black-november/blackPlanTable';
import PlanTable from '../../components/planTable';
import PlanTableWithCupom from '../../components/planTable/withCupom';

import QualityTable from '../../components/qualityTable';
import CountdownBlack from '../../components/countdown-black';
import StepsAndPreview from '../../components/stepsAndPreview';
import AnimatedCounter from '../../components/animated-counter';
import CarouselComments from '../../components/carousel-comments';
import CountdownBlackLP from '../../components/countdown-black-lp';
import RegistrationAndLogin from '../../components/registrationAndLogin';

import * as S from './styles';

export const compendioG = "@compendioG";

const ReceituarioAgronomico2024 = ({ campaign, ...props }) => {
    const [isPromoVisible, setIsPromoVisible] = useState(false);
    const [isBlackNovemberVisible, setIsBlackNovemberVisible] = useState(false);

    const handleBlackNovemberVisibility = (isVisible) => {
        setIsBlackNovemberVisible(isVisible);
    };

    useEffect(() => {
        if (!campaign) {
            setIsPromoVisible(false);
            return;
        }
        const currentDate = new Date();
        const baseTarget = new Date(campaign.data_final);
        const targetDate = new Date(baseTarget.getTime() + 3 * 60 * 60 * 1000);
        setIsPromoVisible(currentDate <= targetDate);
    }, [campaign]);

    // useEffect(() => {
    //     const exit = localStorage.getItem('@exit');
        
    //     if (exit === 'false') {
    //         localStorage.clear();
    //         window.location.reload();
    //     }
    // }, []);

    return (
        <>
            <Helmet>
                <title>Receituário Agronômico 2025</title>
                <meta
                    name="description"
                    content="Descubra as melhores opções de planos e serviços no Receituário Agronômico 2024. Qualidade garantida para o sucesso do seu agronegócio!"
                />
                <meta name="keywords" content="Receituário Agronômico 2024" />
                <meta name="author" content="AgroReceita" />
                <meta property="og:title" content="Receituário Agronômico 2024" />
                <meta property="og:description" content="Explore nossos serviços e planos de qualidade para o agronegócio no Receituário Agronômico 2024." />
                <meta property="og:url" content="https://sistema.agroreceita.com.br/receituario-agronomico-2025" />
            </Helmet>

            <S.Container>
                <CountdownBlackLP onVisibilityChange={handleBlackNovemberVisibility} campaign={campaign}/>

                <S.Wrapper>
                    <RegistrationAndLogin />

                    <Carousel />

                    <CountdownBlack onVisibilityChange={handleBlackNovemberVisibility} campaign={campaign}/>

                    <StepsAndPreview />

                    <AnimatedCounter />

                    <CarouselComments />

                    <QualityTable />

                    {/* <BlackPlanTable /> */}

                     {isPromoVisible ? (
                        <PlanTableWithCupom campaign={campaign} />
                    ) : (
                        <PlanTable />
                    )}

                    <S.ContainerFooter>
                        <Footer />
                    </S.ContainerFooter>
                </S.Wrapper>
            </S.Container>
        </>
    );
};

export default withRouter(ReceituarioAgronomico2024);
